import * as testData from '../mocks/testData';
import { testStatementPosition } from './statementPosition';
import { TestQueryModel } from './types';

export const SQLEditorTestUtils = {
  testData,
  testStatementPosition,
};

export type { TestQueryModel };
